import { BaseNativeDispatcher } from '../base_native_dispatcher';
import { WebViewDispatcherAction } from './web_view_dispatcher.constants';

interface BaseWebViewMessage {
  action: WebViewDispatcherAction;
}

interface InitialisedMessage extends BaseWebViewMessage {
  action: WebViewDispatcherAction.initialised;
}

interface SetBadgeCountMessage extends BaseWebViewMessage {
  action: WebViewDispatcherAction.setBadgeCount;
  payload: {
    count: number;
  };
}

export type WebViewMessage = InitialisedMessage | SetBadgeCountMessage;

export const webViewDispatcher = new BaseNativeDispatcher<WebViewMessage>('webViewHandler');
